import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { StatusChip } from '../ui';
import { formatCurrency } from '../../utils/currencyFormatter';

const buildMyOrdersColumns = ({ t, i18n, onView }) => [
  {
    field: 'orderNumber',
    headerName: t('Order'),
    flex: 1.6,
    minWidth: 180,
    renderCell: (params) => (
      <Box sx={{ minWidth: 0 }}>
        <Typography variant="subtitle1" noWrap>{t('Order #')}{params.row.orderNumber}</Typography>
        <Typography variant="body2" color="text.secondary" noWrap>
          {params.row.createdAt ? new Date(params.row.createdAt).toLocaleDateString() : ''}
        </Typography>
      </Box>
    ),
  },
  {
    field: 'status',
    headerName: t('Status'),
    flex: 0.9,
    minWidth: 120,
    renderCell: (params) => <StatusChip status={params.value} label={t(params.value)} />,
  },
  {
    field: 'itemCount',
    headerName: t('Items'),
    flex: 0.6,
    minWidth: 90,
    sortable: false,
    renderCell: (params) => <Typography variant="body2">{params.row.orderItems?.length || (params.row.productId ? 1 : 0)}</Typography>,
  },
  {
    field: 'totalPrice',
    headerName: t('Total'),
    flex: 0.8,
    minWidth: 100,
    align: 'right',
    headerAlign: 'right',
    renderCell: (params) => <Typography variant="subtitle1">{formatCurrency(params.value, 'USD', i18n.language)}</Typography>,
  },
  {
    field: 'actions',
    headerName: '',
    width: 72,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <IconButton size="small" onClick={() => onView(params.row)} aria-label={t('View order', { defaultValue: 'View order' })}>
        <VisibilityIcon fontSize="small" />
      </IconButton>
    ),
  },
];

export default buildMyOrdersColumns;
